
    import {Component, Prop} from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import {VerifySmsCodeInputDto} from "../entities/VerifySmsCodeInputDto";

    @Component
    export default class SmsVerification extends AbpBase {
        @Prop({type: Boolean, default: false}) value: boolean;
        sms: VerifySmsCodeInputDto = <VerifySmsCodeInputDto>{};

        save() {
            (this.$refs.smsForm as any).validate(valid => {
                if (valid) {
                    this.$store.dispatch('profile/verifySmsCode', this.sms)
                        .then(rs => {
                            abp.notify.success(
                                this.L('VerifiedSmsCodeSuccessfully')
                            );
                            this.$emit('input', false);
                        }).catch(reason => {
                        this.$Notice.error({
                            title: '验证消息号失败!!',
                            desc: reason.response.statusText
                        })
                    })
                }
            });
        }

        cancel() {
            this.$emit('input', false);
        };

        async visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {

            }
        }

        rules = {
            code: [
                {
                    required: true,
                    message: this.L('TheFieldIsRequired', this.L('YourCode')),
                    trigger: 'blur,change'
                }
            ]
        }
    }
